import React, { useEffect, useMemo, useState } from "react";
import t from "../../../helpers/t";
import useHeatMapFilter from "../../../helpers/useHeatMapFilter";
import SidebarFilter from "../../../components/SidebarFilter";
import DatePicker from "react-datepicker";
import moment from "moment";

const FilterHeatMap = (props) => {
  const [filter, setFilter] = useHeatMapFilter();
  const [startState, setStartState] = useState(false);
  const [endState, setEndState] = useState(false);

  const dateInit = () => {
    const now = new Date();
    const to = moment(now).endOf("day").toDate();
    const from = moment(now).subtract(30, "days").toDate();
    return { from, to };
  };

  useEffect(() => {
    const handleChangeFilter = setTimeout(() => {
      props.onFilterChange(filter);
    }, 800);
    return () => clearTimeout(handleChangeFilter);
  }, [filter]);

  const [filterNumberTitle, filterNumberType] = useMemo(() => {
    return filter.filter_type === 1 // filterType.speed
      ? ["filter_by_speed", "maxSpeed"]
      : ["filter_by_number", "amountOfRoutes"];
  }, [filter.filter_type]);

  const validateInputText = (evt) => {
    var theEvent = evt || window.event;
    // Handle paste
    if (theEvent.type === "paste") {
      key = event.clipboardData.getData("text/plain");
    } else {
      // Handle key press
      var key = theEvent.keyCode || theEvent.which;
      key = String.fromCharCode(key);
    }
    var regex = /[0-9,\.]/;
    if (!regex.test(key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
    var value = evt.target.value;
    return value;
  };

  const getDate = (date) => {
    const year = date.getFullYear();
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);
    const withHyphens = [year, month, day].join("-");
    return withHyphens;
  };
  return (
    <div className="dashboard-sidebar-content">
      <SidebarFilter
        id="inb-c-left-bar-flist--filter-hm-type"
        heading=""
        type="list"
        data={[
          { name: t("count_units"), value: 0 },
          { name: t("speed"), value: 1 }, // filterType.speed
        ]}
        dataKey="value"
        selected={filter["filter_type"]}
        onChangeHandle={(value) =>
          setFilter({
            type: "SET",
            key: "filter_type",
            value: value === 1 ? value : 0,
          })
        }
      />
      <SidebarFilter
        id="inb-c-left-bar-flist--filter-hm-date"
        heading={t("filter_by_date")}
        type="datePicker"
        data={[
          {
            name: "date_from",
            className: "noBorders-noBackground",
            dateFormat: "dd.MM.y",
            selected: filter["from"],
            onChangeHandle: (date) =>
              date
                ? setFilter({ type: "SET", key: "from", value: date })
                : setFilter({ type: "SET", key: "from", value: dateInit().from }),
            placeholder: t("valid_from", null, "capital") + " ...",
          },
          {
            name: "date_to",
            className: "noBorders-noBackground",
            dateFormat: "dd.MM.y",
            selected: filter["to"],
            onChangeHandle: (date) =>
              date
                ? setFilter({ type: "SET", key: "to", value: date })
                : setFilter({ type: "SET", key: "to", value: dateInit().to }),
            placeholder: " ..." + t("valid_to", null, "capital"),
          },
        ]}
      />
      <ul className="inb-vert-list">
        <span className="inb-list-title">{t("filter_by_time")}</span>
        <div>
          <DatePicker
            value={
              startState
                ? ("0" + filter["from"].getHours()).slice(-2) +
                  ":" +
                  ("0" + filter["from"].getMinutes()).slice(-2)
                : ""
            }
            placeholderText={t("start_time")}
            onChange={(date) => {
              const val =
                ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2);
              const dateStart = new Date(getDate(filter["from"]) + "T" + val);
              val ? setFilter({ type: "SET", key: "from", value: dateStart }) : undefined;
              setStartState(true);
            }}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={15}
            timeCaption="Time"
            timeFormat="HH:mm"
            dateFormat="h:mm aa"
          />
          <DatePicker
            value={
              endState
                ? ("0" + filter["to"].getHours()).slice(-2) +
                  ":" +
                  ("0" + filter["to"].getMinutes()).slice(-2)
                : ""
            }
            placeholderText={t("end_time")}
            onChange={(date) => {
              const val =
                ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2);
              const dateEnd = new Date(getDate(filter["to"]) + "T" + val);
              val ? setFilter({ type: "SET", key: "to", value: dateEnd }) : undefined;
              setEndState(true);
            }}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={15}
            timeCaption="Time"
            timeFormat="HH:mm"
            dateFormat="h:mm aa"
          />
        </div>
      </ul>
      <div className="dashboard-filterHeatmap-kilometer">
        <ul className="inb-vert-list">
          <span className="inb-list-title">{t("filter_by_kilometer")}</span>
          <div>
            <select name="kilometer" id="kilometer">
              <option value="km">km</option>
            </select>
            <input
              type="text"
              className="inb-vert-list"
              value={filter["distance"] === null ? "" : filter["distance"]}
              onChange={(event) => {
                const val = validateInputText(event);
                setFilter({
                  type: "SET",
                  key: "distance",
                  value: val,
                });
              }}
            />
          </div>
        </ul>
      </div>
      <ul className="inb-vert-list">
        <span className="inb-list-title">{t(filterNumberTitle)}</span>
        <input
          type="number"
          value={filter[filterNumberType] === null ? "" : filter[filterNumberType]}
          min={0}
          onChange={(event) => {
            const val = event.target.value;
            val === ""
              ? setFilter({
                  type: "SET",
                  key: filterNumberType,
                  value: null,
                })
              : Number.isFinite(+val)
                ? setFilter({
                    type: "SET",
                    key: filterNumberType,
                    value: +val,
                  })
                : null;
          }}
        />
      </ul>
      <SidebarFilter
        id="inb-c-left-bar-flist--filter-hm-trip-type"
        heading={t("trip_type")}
        type="list"
        data={[
          { name: t("all"), value: 0 },
          { name: t("service"), value: 1 },
          { name: t("booking"), value: 2 },
          { name: t("official"), value: 3 },
        ]}
        dataKey="value"
        selected={filter["trip_type"]}
        onChangeHandle={(value) =>
          setFilter({
            type: "SET",
            key: "trip_type",
            value: [0, 1, 2, 3].includes(value) ? value : 0,
          })
        }
      />
      <div className="dashboard-filterHeatmap-type">
        <p
          onClick={() => {
            setFilter({ type: "RESET" });
            setStartState(false);
            setEndState(false);
          }}
        >
          {t("reset_filter")}
        </p>
      </div>
    </div>
  );
};

export default FilterHeatMap;
